
import HtmlRenderContainer from '@/components/content-management/html-render-container';

export default {
  props: {
    letter: {
      type    : String,
      require : true
    },
    type: {
      type    : String,
      default : 'default'
    },
    shouldActivateHover: {
      type    : Boolean,
      default : true
    },
    html: {
      type    : String,
      require : true
    }
  },
  components: {
    HtmlRenderContainer
  }
};
